import { addDoc, collection, deleteDoc, doc, getDocs, getId, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async (account, menu) => {
  const snapshot = await getDocs(collection(db, `menus/${account}/menu/${menu}/categories`));
  const categories = snapshot.docs.map((doc) => ({ id: doc.id, order: 0, active: false, ...doc.data() }));
  return categories.sort((oldRelease, newRelease) => {
    const compareOrder = `${oldRelease.order}`.localeCompare(`${newRelease.order}`);
    const compareName = oldRelease.name.localeCompare(newRelease.name);
    return compareOrder || compareName;
  });
};

const add = async (account, menu, data) => {
  await addDoc(collection(db, `menus/${account}/menu/${menu}/categories`), data);
  return data;
};

const edit = async (account, menu, id, data) => {
  await updateDoc(doc(db, `menus/${account}/menu/${menu}/categories`, id), {
    ...data,
  });
};

const remove = async (account, menu, id) => {
  await deleteDoc(doc(db, `menus/${account}/menu/${menu}/categories`, id));
};

const funcs = {
  getAll,
  add,
  edit,
  remove,
};

export default funcs;
